<template>
  <div>
    <v-btn :to="{ name : 'calendar' }" color="none" icon>
      <v-icon>arrow_left</v-icon>
    </v-btn>

    <v-container>
      <v-form
          ref="form"
          lazy-validation
      >
        <v-text-field
            v-model="title"
            :label="$t('calendar.create.title')"
            :rules="[v => !!v || $t('base.field_is_required')]"
            required
        ></v-text-field>

        <v-textarea
            v-model="description"
            :label="$t('calendar.create.description')"
            :rules="[v => !!v || $t('base.field_is_required')]"
            required
        ></v-textarea>

        <v-layout>
          <v-flex xs6>
            <v-menu
                v-model="menuFrom"
                :close-on-content-click="false"
                :nudge-right="40"
                full-width
                lazy
                min-width="290px"
                offset-y
                transition="scale-transition"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                    v-model="scheduledAt"
                    clearable
                    :label="$t('calendar.create.from_date')"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="scheduledAt" @input="menuFrom = false"></v-date-picker>
            </v-menu>
          </v-flex>

          <v-flex xs6>
            <v-menu v-model="menuTime" :close-on-content-click="false" :nudge-right="40" full-width
                    lazy min-width="290px" offset-y transition="scale-transition">
              <template v-slot:activator="{ on }">
                <v-text-field v-model="scheduleTime" :label="$t('calendar.create.from_hour')" clearable
                              prepend-icon="event" readonly
                              v-on="on"></v-text-field>
              </template>

              <v-time-picker
                  v-model="scheduleTime"
                  :landscape="true"
                  format="24hr"
                  @input="menuTime = false">
              </v-time-picker>
            </v-menu>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs6>
            <v-menu
                v-model="menuFinished"
                :close-on-content-click="false"
                :nudge-right="40"
                full-width
                lazy
                min-width="290px"
                offset-y
                transition="scale-transition"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                    v-model="finishedAt"
                    clearable
                    :label="$t('calendar.create.to_date')"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="finishedAt" @input="menuFinished = false"></v-date-picker>
            </v-menu>
          </v-flex>

          <v-flex xs6>
            <v-menu
                v-model="menuHourFinished"
                :close-on-content-click="false"
                :nudge-right="40"
                full-width
                lazy
                min-width="290px"
                offset-y
                transition="scale-transition"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                    v-model="finishedHour"
                    clearable
                    :label="$t('calendar.create.to_hour')"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                ></v-text-field>
              </template>
              <v-time-picker
                  v-model="finishedHour"
                  :landscape="true"
                  format="24hr"
                  @input="menuHourFinished = false">
              </v-time-picker>
            </v-menu>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex xs12>
            <v-autocomplete
                v-model="selectedUsers"
                :item-text="item =>`${item.name} ${item.surname}`"
                :items="users"
                item-value="id"
                label="Users"
                multiple>

              <template v-slot:selection="props">
                {{ props.item.name }}
                {{ props.item.surname }}
                {{ (props.index != selectedUsers.length - 1) ? ', ' : '' }}
              </template>

            </v-autocomplete>
          </v-flex>
        </v-layout>

        <v-btn
            color="green"
            @click="submit"
        >
          {{ $t('calendar.create.create') }}
        </v-btn>

      </v-form>

    </v-container>
  </div>
</template>

<script>
const OTHER = 1
const NEW_FORM = 2
import Messenger from "@/plugins/Messenger"

export default {
  name: "New",
  data() {
    return {
      title: "",
      description: "",
      selectedUsers: [],
      menuFrom: false,
      type: 1,
      scheduleTime: null,
      menuHourFinished: false,
      menuTime: false,
      finishedHour: null,
      scheduledAt: null,
      finishedAt: null,
      menuFinished: null,
      types: [
        {'name': this.$t('calendar.base.new_form'), 'type': NEW_FORM},
        {'name': this.$t('calendar.base.other'), 'type': OTHER}
      ],
      schemas: [],
      eventData: {}
    }
  },
  computed: {
    users() {
      return this.$store.getters.users
    }
  },
  mounted() {
    if (this.$route.query.date) {
      this.scheduledAt = this.$route.query.date
    }
  },
  created() {
    this.getSchemas()
    if (this.$route.params.id) {
      this.$http.get('calendar/' + this.$route.params.id).then(data => {
        Object.assign(this, data.data)
        let date = data.data.scheduledAt.split(' ')
        let dateTo = data.data.finishedAt.split(' ')
        this.scheduledAt = date.length > 0 ? date[0] : ""
        this.scheduleTime = date.length == 2 ? this.getHourAndMinutes(date[1]) : ""
        this.finishedAt = dateTo[0]
        this.finishedHour = dateTo.length == 2 ? this.getHourAndMinutes(dateTo[1]) : ""
        this.selectedUsers = data.data.users
      })
    }
  },
  methods: {
    submit() {
      if (!this.validate()) {
        return
      }

      let {title, description, type, eventData, scheduledAt, scheduleTime, finishedAt, finishedHour} = this
      let formData = {
        title, description, type, eventData,
        scheduledAt: (scheduledAt && scheduleTime) ? scheduledAt + " " + scheduleTime : null,
        finishedAt: (finishedAt && finishedHour) ? finishedAt + " " + finishedHour : null,
        users: this.selectedUsers
      };

      this.send(formData).then(() => {
        Messenger.emitSuccess("Utworzono event!")
        this.$router.push('/calendar')
      }).catch(() => {
        Messenger.emitError("Bład! Nie można utworzyć eventu")
      })

    },
    getSchemas() {
      this.$http.get('schemas').then(data => {
        this.schemas = data.data
      })
    },
    validate() {
      if (!this.title) {
        Messenger.emitError(this.$t('calendar.create.error.title'))
        return false
      }
      if (!this.scheduledAt) {
        Messenger.emitError(this.$t('calendar.create.error.start_date'))
        return false
      }
      if (!this.type) {
        Messenger.emitError(this.$t('calendar.create.error.type'))
        return false
      }
      return true
    },
    send(formData) {
      let url = this.$route.params.id ? `calendar/${this.$route.params.id}` : 'calendar'
      return this.$route.params.id ? this.$http.put(url, formData) : this.$http.post(url, formData)
    },
    getHourAndMinutes(time) {
      if (time.split(":").length == 3) {
        return time.split(":")[0] + ":" + time.split(":")[1]
      }

      if (time.split(":").length == 2) {
        return time
      }

      return ""
    }
  },
}
</script>

<style scoped>

</style>